
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36.382","height":"36.381"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.882 18.19A17.691 17.691 0 1118.191.5a17.69 17.69 0 0117.691 17.69","fill":"#5686f6","stroke":"#006aff"}}),_c('text',{attrs:{"transform":"translate(18 22)","fill":"#fff","font-size":"10","font-family":"Poppins"}},[_c('tspan',{attrs:{"x":"-11.195","y":"0"}},[_v('SMS')])])])
          )
        }
      }
    